import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux'
import * as RequestActions from '../../../actions/requestActions';
import BlogeContentSection from '../../custom/bloge-content-section';
import blogeContent from '../../../constatns/bloge';
import BlogeContentHeader from '../../custom/bloge-content-section/Header';


class Bloge extends Component {
  _selectedContentIndex = 0
  constructor(props) {
    super(props);
    this.state = {
      headerContent:blogeContent[this._selectedContentIndex]
    }
    this.setNewFooterStyle = this.setNewFooterStyle.bind(this);
    this.resetFooterStyle = this.resetFooterStyle.bind(this);
    this.slideClickHandler = this.slideClickHandler.bind(this);
  }

  setNewFooterStyle(){
    var footer = document.getElementById('footer-main-content'); 
    var copyRight = document.getElementById('footer-copy-right');  
    footer.style.backgroundColor='rgb(251, 250, 249)';
    footer.style.borderTop='1px solid rgba(100,100,100,0.2)';

    for (var i = 0; i < footer.children.length; i++) {
      var child = footer.children[i];
      for(var j = 0 ; j< child.children.length ; j++ )
      child.children[j].style.color = '#000';
    }
    copyRight.style.backgroundColor='rgb(251, 250, 249)';
    copyRight.style.color = '#000';
  }

  resetFooterStyle(){
    var footer = document.getElementById('footer-main-content'); 
    var copyRight = document.getElementById('footer-copy-right');
    footer.style.backgroundColor='rgb(0, 43, 68)';
    footer.style.borderTop='none';

    for (var i = 0; i < footer.children.length; i++) {
      var child = footer.children[i];
      for(var j = 0 ; j< child.children.length ; j++ )
      child.children[j].style.color = '#fff';
    }
    copyRight.style.backgroundColor='rgb(0, 29, 46)';
    copyRight.style.color = '#fff';
  }


  componentDidMount() {
    var root = document.getElementById('root');
    root.style.backgroundColor='rgb(251, 250, 249)';
    this.setNewFooterStyle();
  }

  componentWillUnmount() {
    var root = document.getElementById('root');
    root.style.backgroundColor='rgb(0, 29, 46)';
    this.resetFooterStyle();
  }

  slideClickHandler(e,key){
    if(key==='next'){
      if(this._selectedContentIndex < blogeContent.length){
        this._selectedContentIndex++;
        this.setState({headerContent:blogeContent[this._selectedContentIndex]})
      }
    }
    if(key==='prev'){
      if(this._selectedContentIndex > 0){
        this._selectedContentIndex--;
        this.setState({headerContent:blogeContent[this._selectedContentIndex]})
      }
    }
  }

  render() {
    const { lang } = this.props;
    const { headerContent } = this.state;
    return (
      <div>
        <BlogeContentHeader lang={lang} content={headerContent} onClickSlide={this.slideClickHandler}/>
        <BlogeContentSection lang={lang} blogeContent={blogeContent} />
      </div>
    )
  }
}


const mapStateToProps = state => ({
  lang: state.request.lang
});


const mapDispatchToProps = dispatch => {
  return bindActionCreators({
    ...RequestActions,
  }, dispatch)

};

export default connect(mapStateToProps, mapDispatchToProps)(Bloge);